// extracted by mini-css-extract-plugin
export default {"cls1":"Hky5vbeIQJlJgsAZWfwf","cls2":"dI1V2RhaZOtsWp59jbZe Hky5vbeIQJlJgsAZWfwf"};